/** Match the Firebase ID in "Cuisines" collection with the image */

export enum OrganizationNames {
	ModKitchen = 'modkitchen',
	FoorRepublic = 'CA-BC-Vancouver-FoodRepublic',
	ClubKitchen = 'clubkitchen',
	GhostKitchenBrandMiss = 'gkb-mississauga',
	KitchenOne = 'kitchenone',
	GKB_BURLINGTON = 'gkb-burlington',
}

export const cuisineImages = {
	Burger: require('../../../assets/images/cuisines/burgers.png'),
	Soup: require('../../../assets/images/cuisines/soup.png'),
	Pizza: require('../../../assets/images/cuisines/pizza.png'),
	Barbecue: require('../../../assets/images/cuisines/bbq.png'),
	Chinese: require('../../../assets/images/cuisines/chinese.png'),
	Greek: require('../../../assets/images/cuisines/greek.png'),
	Mexican: require('../../../assets/images/cuisines/mexican.png'),
	Sushi: require('../../../assets/images/cuisines/sushi.png'),
	Smoothie: require('../../../assets/images/cuisines/smoothies.png'),
	Sandwich: require('../../../assets/images/cuisines/sandwiches.png'),
	Salad: require('../../../assets/images/cuisines/salads.png'),
	Vegan: require('../../../assets/images/cuisines/vegan.png'),
	Poke: require('../../../assets/images/cuisines/poke.png'),
	Dessert: require('../../../assets/images/cuisines/desserts.png'),
	Chicken: require('../../../assets/images/cuisines/chicken.png'),
	'Bubble Tea': require('../../../assets/images/cuisines/bubbletea.png'),
	Bakery: require('../../../assets/images/cuisines/bakery.png'),
	'Coffee & Tea': require('../../../assets/images/cuisines/coffeetea.png'),
	Donair: require('../../../assets/images/cuisines/donair.png'),
	Japanese: require('../../../assets/images/cuisines/japanese.png'),
	'Middle Eastern': require('../../../assets/images/cuisines/middleeastern.png'),
	Persian: require('../../../assets/images/cuisines/persian.png'),
	Vietnamese: require('../../../assets/images/cuisines/vietnamese.png'),
	Ramen: require('../../../assets/images/cuisines/ramen.png'),
	Pasta: require('../../../assets/images/cuisines/pasta.png'),
	'Asian Fusion': require('../../../assets/images/cuisines/asianfusion.png'),
	Indian: require('../../../assets/images/cuisines/indian.png'),
	Seafood: require('../../../assets/images/cuisines/seafood.png'),
	'Ice Cream': require('../../../assets/images/cuisines/icecream.png'),
	Lebanese: require('../../../assets/images/cuisines/lebanese.png'),
	Carribean: require('../../../assets/images/cuisines/carribean.png'),
	Healthy: require('../../../assets/images/cuisines/healthy.png'),
	Korean: require('../../../assets/images/cuisines/korean.png'),
	Steak: require('../../../assets/images/cuisines/steak.png'),
	Breakfast: require('../../../assets/images/cuisines/breakfast.png'),
	Italian: require('../../../assets/images/cuisines/italian.png'),
	Thai: require('../../../assets/images/cuisines/thai.png'),
	'Fast Food': require('../../../assets/images/cuisines/fastfood.png'),
	Drinks: require('../../../assets/images/cuisines/drinks.png'),
	'Show All': require('../../../assets/images/cuisines/showAll.png'),
}

const modKitchenCuisineImages = {
	'Cantonese Bento Boxes': require('../../../assets/images/cuisines/ModImages/bento.png'),
	Burgers: require('../../../assets/images/cuisines/ModImages/burger.png'),
	'Cantonese BBQ': require('../../../assets/images/cuisines/ModImages/cantonesebbq.png'),
	Coffee: require('../../../assets/images/cuisines/ModImages/coffee.png'),
	'Coffee Bean': require('../../../assets/images/cuisines/ModImages/coffeebean.png'),
	'Fried Chicken': require('../../../assets/images/cuisines/ModImages/friedchicken.png'),
	'Health & Wellness': require('../../../assets/images/cuisines/ModImages/healthandwellness.png'),
	'Hot Dog': require('../../../assets/images/cuisines/ModImages/hotdog.png'),
	'Ice Cream': require('../../../assets/images/cuisines/ModImages/icecream.png'),
	Juice: require('../../../assets/images/cuisines/ModImages/juice.png'),
	Lime: require('../../../assets/images/cuisines/ModImages/lime.png'),
	'Mediterranean Wraps': require('../../../assets/images/cuisines/ModImages/mediterraneanwraps.png'),
	Muffin: require('../../../assets/images/cuisines/ModImages/muffin.png'),
	Orange: require('../../../assets/images/cuisines/ModImages/orange.png'),
	Pizza: require('../../../assets/images/cuisines/ModImages/pizza.png'),
	Popsicle: require('../../../assets/images/cuisines/ModImages/popsicle.png'),
	Popsicle2: require('../../../assets/images/cuisines/ModImages/popsicle2.png'),
	Ramen: require('../../../assets/images/cuisines/ModImages/ramen.png'),
	Sausage: require('../../../assets/images/cuisines/ModImages/sausage.png'),
	Seafood: require('../../../assets/images/cuisines/ModImages/seafood.png'),
	'Show All': require('../../../assets/images/cuisines/ModImages/showall.png'),
	Cup: require('../../../assets/images/cuisines/ModImages/cup.png'),
	Steak: require('../../../assets/images/cuisines/ModImages/steak.png'),
	Sushi: require('../../../assets/images/cuisines/ModImages/sushi.png'),
	'Tocha Sauces': require('../../../assets/images/cuisines/ModImages/tochasauces.png'),
	Tray: require('../../../assets/images/cuisines/ModImages/tray.png'),
	Vegetarian: require('../../../assets/images/cuisines/ModImages/vegetarian.png'),
	Wine: require('../../../assets/images/cuisines/ModImages/wine.png'),
}

export const ORGANIZATION_IMAGES_MAP = {
	[OrganizationNames.ModKitchen]: modKitchenCuisineImages,
	[OrganizationNames.FoorRepublic]: cuisineImages,
	[OrganizationNames.ClubKitchen]: cuisineImages,
	[OrganizationNames.GhostKitchenBrandMiss]: cuisineImages,
	[OrganizationNames.KitchenOne]: cuisineImages,
	[OrganizationNames.GKB_BURLINGTON]: cuisineImages,
}
